/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import "./illustrations.scss";
import {
  popupBlockerText,
  RA_STEPS_IDENTIFIERS,
} from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";
import LabelText from "../../atoms/LabelText";

const Illustrations = (props) => {
  const {
    chooseRetirementSteps,
    mixmatchchoice,
    mixmatch,
    regularincome,
    taxfreecash,
    regularchoice,
    data,
  } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const [selectedCheck, setSelectedCheck] = useState(null);
  const navigate = useNavigate();
  const { setIsFinalPage } = props;
  const { illustrationFetching, illustrationData, illustrationError } =
    useSelector(
      (state) => state.viewIllustration // eslint-disable-line
    );

  const handleBack = () => {
    if (
      props?.isActiveMember &&
      (chooseRetirementSteps?.isRegularHowMuchCash ||
        chooseRetirementSteps?.isMixMatchHowMuchCash)
    ) {
      props.makeInitialStepper(false, 37, { isContribution: true }, true);
    } else if (!props?.isActiveMember) {
      props.makeInitialStepper(false, 36, { isConfirmChoice: true }, true);
    }
  };
  const applicationPotsSelected =
    data?.applicationPots?.length > 0
      ? data?.applicationPots
      : JSON.parse(localStorage.getItem("applicationPots"));

  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_ILLUSTRATION;
    let choiceCategory = {
      illustration: { terms: selectedCheck },
      choiceSubmitted: true,
      choiceSelected: regularIncome
        ? "TAKE_TAX_FREE_CASH_REGULAR_INCOME"
        : mixAndMatch
          ? "TAKE_TAX_FREE_CASH_MIX_AND_MATCH"
          : "",
    };
    let payload = {
      currentStep,
      choiceCategory: { ...choiceCategory },
    };
    setIsFinalPage(true);
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_ILLUSTRATION, payload);
  };
  const dispatch = useDispatch();
  const { getIllustrationContent } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  const regularIncome = chooseRetirementSteps?.isRegularHowMuchCash;
  const regularChoicePercentage =
    regularchoice?.choiceCategory?.regularIncome?.percentage;
  const regularInvestTheRest = regularincome?.choiceCategory?.regularIncome;
  const mixAndMatchValues =
    mixmatchchoice?.choiceCategory?.mixNmatch?.cashLumpsum;
  const mixAndMatch = chooseRetirementSteps?.isMixMatchHowMuchCash;
  const mixAndMatchInvestTheRest =
    mixmatch?.choiceCategory?.mixNmatch?.investTheRest;

  let flexiAmountRegularIncome = 0;
  if (regularInvestTheRest?.faFequency === "Annual") {
    flexiAmountRegularIncome = regularInvestTheRest?.faChoosenAmount;
  } else if (regularInvestTheRest?.faFequency === "Monthly") {
    flexiAmountRegularIncome = regularInvestTheRest?.faChoosenAmount * 12;
  } else if (regularInvestTheRest?.faFequency === "Quarterly") {
    flexiAmountRegularIncome = regularInvestTheRest?.faChoosenAmount * 4;
  } else if (regularInvestTheRest?.faFequency === "HalfYearly") {
    flexiAmountRegularIncome = regularInvestTheRest?.faChoosenAmount * 2;
  }
  const totalIncomeRegularIncome =
    parseFloat(regularInvestTheRest?.miCurrentIncome) * 12 + //eslint-disable-line
    parseFloat(regularInvestTheRest?.faIncomeAmount) * 12 + //eslint-disable-line
    parseFloat(
      flexiAmountRegularIncome //eslint-disable-line
    ).toFixed(2);
  let flexiAmountMixMatch = 0;
  if (mixAndMatchInvestTheRest?.faFequency === "Annual") {
    flexiAmountMixMatch = mixAndMatchInvestTheRest?.faAmount;
  } else if (mixAndMatchInvestTheRest?.faFequency === "Monthly") {
    flexiAmountMixMatch = mixAndMatchInvestTheRest?.faAmount * 12;
  } else if (mixAndMatchInvestTheRest?.faFequency === "Quarterly") {
    flexiAmountMixMatch = mixAndMatchInvestTheRest.faAmount * 4;
  } else if (mixAndMatchInvestTheRest?.faFequency === "HalfYearly") {
    flexiAmountMixMatch = mixAndMatchInvestTheRest?.faAmount * 2;
  } else if (mixAndMatchInvestTheRest?.faFequency === "") {
    flexiAmountMixMatch = mixAndMatchInvestTheRest?.faAmount;
  }
  const lumbsumMixMatch = parseFloat(
    mixAndMatchValues?.amount //eslint-disable-line
  );
  const totalIncomeMixMatch = parseFloat(
    (mixAndMatchInvestTheRest?.miPercent / 100) *
      lumbsumMixMatch * //eslint-disable-line
      12 + //eslint-disable-line
      (mixAndMatchInvestTheRest?.safetynetPercent / 100) *
        lumbsumMixMatch * //eslint-disable-line
        12 + //eslint-disable-line
      (mixAndMatchInvestTheRest?.legacyPercent / 100) *
        lumbsumMixMatch * //eslint-disable-line
        12 + //eslint-disable-line
      (mixAndMatchInvestTheRest?.faiPercent / 100) *
        lumbsumMixMatch * //eslint-disable-line
        12 + //eslint-disable-line
      flexiAmountMixMatch //eslint-disable-line
  ).toFixed(2);

  const managedIncomeMixMatch =
    parseFloat(
      mixAndMatchValues?.amount //eslint-disable-line
    ) *
    (mixAndMatchInvestTheRest?.miPercent / 100);
  const handleIllustration = (item) => {
    const payload = {
      investorId: props.investorId,
      investorAccountId: Number(item?.potId),
      incomeFrequency: 12,
      targetTfcPercentage: regularIncome
        ? regularChoicePercentage?.toString()
        : mixAndMatch
          ? mixAndMatchValues?.percentage.toString()
          : "",
      incomeAmount: regularIncome
        ? parseInt(totalIncomeRegularIncome, 10).toString()
        : mixAndMatch
          ? totalIncomeMixMatch.toString()
          : "",
      pensionSavingMem: item?.potId.toString(),
      totalBalance: parseFloat(item?.potValue),
      taxFreeCash: regularIncome
        ? item?.potMonetaryAmount * (regularChoicePercentage / 100) //eslint-disable-line
        : mixAndMatch
          ? parseFloat(
              mixAndMatchValues?.amount //eslint-disable-line
            ) *
            (mixAndMatchValues?.percentage / 100) //eslint-disable-line
          : "",
      taxableLumpSums: regularIncome
        ? item?.potValue -
          item?.potMonetaryAmount * //eslint-disable-line
            (regularChoicePercentage / 100) //eslint-disable-line
        : mixAndMatch
          ? item?.potValue -
            parseFloat(
              mixAndMatchValues?.amount //eslint-disable-line
            ) *
              (mixAndMatchValues?.percentage / 100) //eslint-disable-line
          : "",
      taxablePensionSavings: regularIncome
        ? parseFloat(regularchoice?.riData?.movingToDrawdown.replace(/,/g, ""))
        : mixAndMatch
          ? lumbsumMixMatch
          : "",

      requestedInvestment: [
        {
          managedIncome: {
            fundid:
              parseFloat(regularInvestTheRest?.miAmount) > 0 ||
              managedIncomeMixMatch > 0
                ? props.miId
                : 0,
            fundValue: regularIncome
              ? parseFloat(regularInvestTheRest?.miAmount)
              : mixAndMatch
                ? managedIncomeMixMatch
                : "",
          },
          futureAnnuity: {
            fundid:
              parseFloat(regularInvestTheRest?.faIncomeAmount) > 0 ||
              parseFloat(mixAndMatchInvestTheRest?.annuityAmount) > 0
                ? props.faiId
                : 0,
            fundValue: regularIncome
              ? parseFloat(
                  regularInvestTheRest?.faIncomeAmount //eslint-disable-line
                ) //eslint-disable-line
              : mixAndMatch
                ? parseFloat(
                    mixAndMatchInvestTheRest?.annuityAmount //eslint-disable-line
                  )
                : "",
          },

          flexiAccess: {
            fundValue: regularIncome
              ? parseFloat(regularInvestTheRest?.faAmount)
              : mixAndMatch
                ? parseFloat(
                    mixAndMatchInvestTheRest?.faAmount //eslint-disable-line
                  )
                : "",
          },

          safetyNet: {
            fundid:
              mixAndMatchInvestTheRest?.safetynetPercent > 0 ? props.snId : 0,
            fundValue: regularIncome
              ? 0
              : mixAndMatch
                ? parseFloat(
                    mixAndMatchValues?.amount //eslint-disable-line
                  ) *
                  (mixAndMatchInvestTheRest?.safetynetPercent / 100)
                : "",
          },

          legacy: {
            fundid:
              mixAndMatchInvestTheRest?.legacyPercent > 0 ? props.leId : 0,
            fundValue: regularIncome
              ? 0
              : mixAndMatch
                ? parseFloat(
                    mixAndMatchValues?.amount //eslint-disable-line
                  ) *
                  (mixAndMatchInvestTheRest?.legacyPercent / 100)
                : "",
          },
        },
      ],
      managedIncomePaymentPerMonth: regularIncome
        ? regularInvestTheRest?.miCurrentIncome?.toString()
        : mixAndMatch
          ? (managedIncomeMixMatch / 12).toString()
          : "",
      futureAnnuityIncomePaymentPerMonth: regularIncome
        ? regularInvestTheRest?.faCurrentIncome?.toString()
        : mixAndMatch
          ? (
              parseFloat(
                mixAndMatchInvestTheRest?.annuityAmount //eslint-disable-line
              ) / 12
            ).toString()
          : "",
      futureFlexiAccessPaymentAmount: regularIncome
        ? regularInvestTheRest?.faChoosenAmount?.toString()
        : mixAndMatch
          ? (
              parseFloat(
                mixAndMatchInvestTheRest?.faAmount //eslint-disable-line
              ) / 12
            ).toString()
          : "",
      flexiAccessIncomePaymentFrequency: regularIncome
        ? regularInvestTheRest?.faFequency?.toString()
        : mixAndMatch
          ? mixAndMatchInvestTheRest?.faFequency.toString()
          : "",
      totalRegularIncome: regularIncome
        ? totalIncomeRegularIncome?.toString()
        : mixAndMatch
          ? totalIncomeMixMatch?.toString()
          : "",
      retirementId: props.retirementId ? props.retirementId : 0,
    };
    handleIllustrationClick(payload);
  };
  const handleIllustrationClick = async (payload) => {
    try {
      const result = await getIllustrationContent(payload);
      const base64String = result?.encodedPdf;

      if (!base64String) {
        alert("Document content not found.");
        return;
      }

      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error opening document:", error);
      alert("Failed to open document.");
    }
  };

  return (
    <>
      <Card className="application-step">
        <Card.Body className="illustrations">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance _title">Illustrations for retirement </p>
            </Col>
          </Row>
          <Row className="ourter-bg">
            <Col md={7} className="bg-text">
              We have put together an illustration detailing how your chosen
              options will affect your savings. Please view this illustration in
              your <b>Documents</b> area.
            </Col>
          </Row>
          {applicationPotsSelected?.map((item) => (
            <div key={item.id}>
              <Col md={4} key={item.id} className="mb-2">
                <a
                  className="tertiary w-auto download-btn"
                  rel="noreferrer"
                  onClick={() => {
                    handleIllustration(item);
                  }}
                >
                  {item?.potId + "_Illustration.pdf"}
                </a>
              </Col>
              {illustrationFetching ? <LoadingSpinner /> : ""}
              {illustrationError ? (
                <NotFound err="Unable to load illustration" />
              ) : (
                ""
              )}
            </div>
          ))}
          <Row className="mb-3">
            <LabelText text={popupBlockerText} />
          </Row>
          <Row>
            <div className="your-confirmation"> Your confirmations</div>
            <Col md={12} className="bg-text">
              <div className="check-box">
                <CustomCheckbox
                  name="pension-wise-guidance"
                  label="I have read through my illustrations and agree to continue"
                  variantName="custom-checkbox mt-3"
                  onChange={() => {
                    setSelectedCheck(true);
                  }}
                />
              </div>
            </Col>
            <Col md={6}></Col>
          </Row>

          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />

            <Buttons
              handleClick={() => handleContinue()}
              className="primary"
              name="Continue"
              disabled={selectedCheck ? false : true}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
export default Illustrations;
